import React from "react";

function closeIcon() {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.911 9.00135L17.5967 2.31463C18.1272 1.78403 18.1272 0.928561 17.5967 0.397955C17.0662 -0.132652 16.2108 -0.132652 15.6803 0.397955L9 7.08467L2.31429 0.397955C1.78376 -0.132652 0.928421 -0.132652 0.397895 0.397955C-0.132632 0.928561 -0.132632 1.78403 0.397895 2.31463L7.08361 9.00135L0.397895 15.6881C-0.132632 16.2187 -0.132632 17.0741 0.397895 17.6048C0.663158 17.8701 1.00962 18 1.35609 18C1.70256 18 2.04902 17.8701 2.31429 17.6048L9 10.918L15.6857 17.5993C15.951 17.8646 16.2974 17.9946 16.6439 17.9946C16.9904 17.9946 17.3368 17.8646 17.6021 17.5993C18.1326 17.0687 18.1326 16.2133 17.6021 15.6827L10.911 9.00135Z"
        fill="#424242"
      />
    </svg>
  );
}

export default closeIcon;
